import styled from 'styled-components'

import { theme } from '../../constants'

export const Page = styled.div`
  min-height: 100vh;
  padding: ${theme.spacing[8]} ${theme.layout.contentGutter};
  color: ${theme.semanticColors.text.primary};
  background: ${theme.semanticColors.background.canvas};
  font-family: ${theme.typography.family};
  text-align: left;

  * {
    box-sizing: border-box;
  }
`

export const PageInner = styled.main`
  width: 100%;
  max-width: ${theme.layout.contentMaxWidth};
  margin: 0 auto;
`

export const Header = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${theme.spacing[6]};
  margin-bottom: ${theme.spacing[8]};

  h1 {
    margin: ${theme.spacing[1]} 0;
    font-size: ${theme.typography.size.h1};
    line-height: ${theme.typography.lineHeight.heading};
  }

  p,
  span {
    margin: 0;
    color: ${theme.semanticColors.text.secondary};
  }

  > div:first-child > span {
    color: ${theme.roleColors.admin.strong};
    font-size: ${theme.typography.size.bodySmall};
    font-weight: ${theme.typography.weight.bold};
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    flex-direction: column;
  }
`

export const Toolbar = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${theme.spacing[3]};
  margin-bottom: ${theme.spacing[6]};

  label {
    display: grid;
    flex: 1;
    gap: ${theme.spacing[2]};
    color: ${theme.semanticColors.text.secondary};
    font-size: ${theme.typography.size.bodySmall};
    font-weight: ${theme.typography.weight.semibold};
  }

  input {
    width: 100%;
    min-height: ${theme.layout.controlHeight};
    padding: 10px 14px;
    color: ${theme.semanticColors.text.primary};
    background: ${theme.semanticColors.background.surface};
    border: 1px solid ${theme.semanticColors.border.default};
    border-radius: ${theme.radii.medium};
    font: inherit;

    &:focus-visible {
      outline: none;
      box-shadow: ${theme.shadows.focus};
    }
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    align-items: stretch;
    flex-direction: column;
  }
`

export const Panel = styled.section`
  padding: ${theme.spacing[6]};
  background: ${theme.semanticColors.background.surface};
  border: 1px solid ${theme.semanticColors.border.default};
  border-radius: ${theme.radii.xlarge};
  box-shadow: ${theme.shadows.small};
`

export const StatusMessage = styled.div<{ $error?: boolean }>`
  padding: ${theme.spacing[8]} ${theme.spacing[4]};
  color: ${({ $error }) =>
    $error ? theme.colors.error : theme.semanticColors.text.secondary};
  text-align: center;

  p {
    margin: 0 0 ${theme.spacing[4]};
  }
`

export const ProfileList = styled.ul`
  display: grid;
  gap: ${theme.spacing[3]};
  margin: 0;
  margin-top: ${theme.spacing[4]};
  padding: 0;
  list-style: none;
`

export const ProfileRow = styled.li`
  min-height: 76px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(220px, auto);
  align-items: center;
  gap: ${theme.spacing[6]};
  padding: ${theme.spacing[4]};
  background: ${theme.semanticColors.background.elevated};
  border: 1px solid ${theme.semanticColors.border.default};
  border-radius: ${theme.radii.large};

  strong,
  span {
    display: block;
  }

  span {
    margin-top: ${theme.spacing[1]};
    overflow-wrap: anywhere;
    color: ${theme.semanticColors.text.secondary};
    font-size: ${theme.typography.size.bodySmall};
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
    gap: ${theme.spacing[3]};
  }
`

export const VersionField = styled.label`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${theme.spacing[3]};
  color: ${theme.semanticColors.text.secondary};
  font-size: ${theme.typography.size.bodySmall};
  font-weight: ${theme.typography.weight.semibold};

  select {
    min-width: 132px;
    min-height: ${theme.layout.controlHeight};
    padding: 8px 36px 8px 12px;
    color: ${theme.semanticColors.text.primary};
    background-color: ${theme.semanticColors.background.surface};
    border: 1px solid ${theme.semanticColors.border.strong};
    border-radius: ${theme.radii.medium};
    font: inherit;
    cursor: pointer;

    &:focus-visible {
      outline: none;
      box-shadow: ${theme.shadows.focus};
    }

    &:disabled {
      cursor: wait;
      opacity: 0.58;
    }
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    align-items: stretch;
    flex-direction: column;
  }
`
